import BaseService from "./base.service";
import { CONFIG } from "@/config";

class EnrollmentsService extends BaseService {
  get entity() {
    return "enrollments";
  }
  getMyCourses(includeExpired = false, includes = null) {
    return new Promise((resolve, reject) => {
      let endpoint = `${this.entity}?includeExpired=${includeExpired}`;
      if (includes) {
        endpoint = `${this.entity}?includeExpired=${includeExpired}&include=${includes}`;
      }
      return this.request({ auth: true })
        .get(endpoint)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getMyExtendableEnrollments() {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`${this.entity}/extendable`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }

  getEnrollment(enrollmentId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .get(`${this.entity}/${enrollmentId}?include=course.contract`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
}
export default new EnrollmentsService();
